<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">{{ location }}</h2>
      <span>|</span>
      <h2 class="title title-primary">
        {{ $t("lang.inventory.dashboard.page_title_line_1") }}
      </h2>
      <span>|</span>
      <h3 class="title title-primary">
        {{ $t("lang.inventory.dashboard.page_title_line_2") }}
      </h3>
    </div>
    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">
        <bx-box dark color="outline" class="col-6 col-md-auto p-1">
          <bx-value
            :label="$t('lang.epc.readings')"
            :value="readings"
            font-size="xs"
            valueColor="red"
          />
        </bx-box> 
      </div>
      <skeleton-boxes :boxes="7" v-else />
    </div>

    <!-- <skeleton-boxes :boxes="7" v-else /> -->

    <div class="epc-form">
      <h6>{{ $t("lang.epc.epc-find") }}</h6>
      <div class="centros-form">
        <form>
          <div class="form-row">
            <div class="col-md-6">
              <v-text-field
                :label="$t('lang.epc.epc')"
                outlined
                v-model="epc"
              ></v-text-field>
            </div>
            <div class="col-md-6">
            <v-btn
              color="#FF5800"
              class="px-10"
              style="height: 55px"
              @click="submit"
              :loading="shouldLoading"
              :disabled="shouldLoading"
              >Submit</v-btn>
            </div>
            <div v-if="errors.length">
                <div class="alert alert-danger" role="alert">
                  <ul style="list-style-type: circle;margin: 10px">
                    <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                  </ul>
                </div>
            </div>
        </div>

        </form>
      </div>
    </div>
    <div class="page-main-content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
              <skeleton-table :columns="6" v-if="shouldLoading" />
              <bx-table
                :data="data"
                :columns="filteredHeaders"
                paginated
                v-if="!shouldLoading && item" 
                :currentPage="page"
                :perPage="itemsPerPage"
                backendPagination
                :total="readings"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column centered class="pt-5">{{
                    props.row.id
                  }}</bx-table-column>
                  <bx-table-column centered class="pt-5">{{
                    props.row.date
                  }}</bx-table-column>
                 <bx-table-column centered class="pt-5" v-if="props.row.state === 0">
                      STOCKED
                  </bx-table-column>
                  <bx-table-column centered class="pt-5" v-else-if="props.row.state === 1">
                      UNKNOW
                  </bx-table-column>
                 <bx-table-column centered class="pt-5" v-else-if="props.row.state === 2">
                      IN TRANSIT
                  </bx-table-column>
                  <bx-table-column centered class="pt-5" v-else-if="props.row.state === 3">
                      SOLD
                  </bx-table-column>
                  <bx-table-column centered class="pt-5" v-else-if="props.row.state === 4">
                      RETURNED TO SUPPLIER
                  </bx-table-column>
                  <bx-table-column centered class="pt-5">
                      {{props.row.area1.description}}-{{props.row.area1.location_description}}
                  </bx-table-column>
                  <bx-table-column centered class="pt-5" v-if="props.row.area2">
                      {{props.row.area2.description}}-{{props.row.area2.location_description}}
                  </bx-table-column>
                  <bx-table-column centered class="pt-5" v-else>
                      {{props.row.area2}}
                  </bx-table-column>
                  <bx-table-column centered class="pt-5">
                      {{props.row.readingSet}}
                  </bx-table-column>
                </template>
              </bx-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "EPCDashboard",
  data() {
    return {
      epc: null,
      shouldLoading: false,
      readings: 0,
      data: [],
      item: null,
      errors: [],
      errorLabels: {
        not_found: "Not found" ,
      },
      columns : [
            {
              field: "id",
              label: this.$t("lang.epc.id"),
              centered: true,
              display: true
            },
            {
              field: "date",
              label: this.$t("lang.epc.date"),
              centered: true,
              display: true
            },
            {
              field: "state",
              label: this.$t("lang.epc.state"),
              centered: true,
              display: true
            },
            {
              field: "area1",
              label: this.$t("lang.epc.area_location"),
              centered: true,
              display: true
            },
            {
              field: "location",
              label: this.$t("lang.epc.area_location_destination"),
              centered: true,
              display: true
            },
            {
              field: "reading_set",
              label: this.$t("lang.epc.reading_set"),
              centered: true,
              display: true
            },

          ],
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      page: 1
    };
  },
  async mounted() {
    this.epc = this.$route.params.epc;
    this.getData();
    if(this.epc!=null)
      this.submit();

  },
    computed: {
    filteredHeaders() {
      if (this.columns) {
        return this.columns.filter(header => header.display === true);
      }
      return [];
    },
    location() {
      return localStorage.getItem("location");
    },
  },
  methods: {
    updatePage(p) {
      this.page = p;
      this.submit();
    },
    async getData() {
      try {
        // Load stats
        let location = localStorage.getItem("location");
        let locationId = localStorage.getItem("location_id");
        if (!location || !locationId) {
          try {
            let firstLocation = await this.$api.location.search("", {
              limit: 1,
              offset: 0,
              orderBy: "id"
            });
            location = firstLocation.results[0].description;
            locationId = firstLocation.results[0].id;
          } catch (error) {
            console.log(error);
          }
        }
      } catch (error) {
        // console.log(error)
      } finally {
        this.shouldLoading = false;
      }
    },
    async submit() {
      if(this.epc==null || this.epc==""){
        this.errors.push(this.errorLabels.not_found);
        return;
      }
      this.shouldLoading = true;
      console.log(this.epc);
      try {
        this.item = await this.$api.epc.retrieve_epc({"epc":this.epc});
        if(this.item.length>0){
        let epcs = await this.$api.epc.item_stock(this.item[0].id, 
        { offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage
        });
        this.data = epcs.results;
        this.readings = epcs.count;
        }
      } catch (error) {
        console.error(error);
      } finally {
        setTimeout(() => {
          this.columns = [
            {
              field: "id",
              label: this.$t("lang.epc.id"),
              centered: true,
              display: true
            },
            {
              field: "date",
              label: this.$t("lang.epc.date"),
              centered: true,
              display: true
            },
            {
              field: "state",
              label: this.$t("lang.epc.state"),
              centered: true,
              display: true
            },
            {
              field: "area1",
              label: this.$t("lang.epc.area_location"),
              centered: true,
              display: true
            },
            {
              field: "location",
              label: this.$t("lang.epc.area_location_destination"),
              centered: true,
              display: true
            },
            {
              field: "reading_set",
              label: this.$t("lang.epc.reading_set"),
              centered: true,
              display: true
            },

          ];
          this.shouldLoading = false;
          this.selectedRecords = [];
          this.selectedRows = [];
        }, 100);
      }
    }
  }
};
</script>